import { AudioManager } from '../core/AudioManager';
import { GameManager } from '../core/GameManager';
import { AbstractScene } from './AbstractScene';
export class GameScene extends AbstractScene {
    constructor() {
        super('game');
    }
    init() {
        this.zoomScale = 1;
        super.init();
    }
    preload() {
        this.scene.launch('ui');
    }
    createGameElements() {
        this.audioManager = new AudioManager(this);
        this.audioManager.initGameAudio();
        this.gameManager = new GameManager(this);
    }
    create() {
        this.createGameElements();
        this.resizeAndRepositionElements();
    }
    resizeAndRepositionElements() {
        let { width: w, height: h } = this.resizeDim;
        w /= this.grs.dpr;
        h /= this.grs.dpr;
        if (this.gameManager) {
            this.gameManager.resizeAndRepositionElements(w, h);
        }
    }
    update(time, delta) {
        this.gameManager.update(delta);
    }
}
